export default{draw:'Draw',pan:'Pan',moveText:'Move text',textOptionsTitle:'Text Options',lineOptionsTitle:'Line Options'};